// import server from './server'
import { getServer } from '../utils/share'
import {setStore, getStore, removeStore} from '@/config/mUtils'
import Qs from 'qs'

export default async (url = '', data = {}, type = 'GET', method = 'fetch') => {
  type = type.toUpperCase()
  url = getServer().admin + url

  if (type === 'GET') {
    let dataStr = '' // 数据拼接字符串
    Object.keys(data).forEach(key => {
      dataStr += key + '=' + data[key] + '&'
    })

    if (dataStr !== '') {
      dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
      url = url + '?' + dataStr
    }
  }

  let appKey =  getStore("appKey");
  if(appKey){
    appKey = appKey.appKey
  }

  if (window.fetch && method === 'fetch') {
    let requestConfig = {
      //credentials: 'include',
      method: type,
      headers: {
        'Accept': 'application/json',
        //'Content-Type': 'application/json;charset=utf-8',
        'Content-Type': 'application/x-www-form-urlencoded',
        'appKey': appKey
      },
      mode: 'cors',
      cache: 'no-cache'
    }

    if (type === 'POST') {
      Object.defineProperty(requestConfig, 'body', {
        //value: JSON.stringify(data)
        value: Qs.stringify(data)
      })
    }

    try {
      const response = await fetch(url, requestConfig)
      const responseJson = await response.json()
      return responseJson
    } catch (error) {
      throw new Error(error)
    }
  } else {
    return new Promise((resolve, reject) => {
      let requestObj
      if (window.XMLHttpRequest) {
        requestObj = new XMLHttpRequest()
      } else {
        requestObj = new ActiveXObject()
      }

      let sendData = ''
      if (type === 'POST') {
        //sendData = JSON.stringify(data)
        sendData = Qs.stringify(data)
      }

      requestObj.open(type, url, true)
      requestObj.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
      requestObj.setRequestHeader('appKey', appKey)
      requestObj.send(sendData)

      requestObj.onreadystatechange = () => {
        if (requestObj.readyState === 4) {
          if (requestObj.status === 200) {
            let obj = requestObj.response
            if (typeof obj !== 'object') {
              obj = JSON.parse(obj)
            }
            resolve(obj)
          } else {
            reject(requestObj)
          }
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/config/fetch.js